import React, { useEffect, useState } from 'react'
import styled, { StyledComponent } from 'styled-components'

import { Loader } from '@/common/components/Loader'
import {
    Box,
    BoxOne,
    BoxRight,
    BoxWrapper,
    HeaderLeft,
    HeaderRight,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr
} from '@/common/styled/Subscription.Xtra.Dumb'

import { formatDate } from '@/common/utils/utils'
import {
    BillItemsV2,
    BillingContact,
    BillingEstimation,
    BillingEstimationContainer,
    DateWrapper,
    MonthlySubscriptionV2,
    TableContainerV2,
    UpgradePlanContent
} from './AccountAndBillingv2'
import { OverviewPlanV2 } from './BillingOverview-v2'
import { HeaderPrice } from './BoxLeft'
import { Container, EstimateHeader } from './Headers'
import { BillingWrapper } from './PaidUsersPlan'
import { ContainerV2, CurrentPlanHeader, PlansHeaderV2, WrapperV2 } from './Plans-v2'
import { loadCurrentSubscriptionData } from './Subscription'
import { UpcomingInvoice } from './SubsriptionResponse'
//TYPE IMPORT
import {
    ActionT,
    ErrorPage,
    PageStateT,
    ResourceConsumptionForDisplay,
    ResourceDetails,
    ResourceDisplay,
    TrialStatus
} from './kind'
import { billingEmail, stripeUTCDate } from './util-stripe'

export const DateLogs = styled.div`
    width: 100%;
    float: left;
    font-family: 'Gordita-Regular';
    cursor: default;
    font-size: 16px;
    color: #494949;
    display: flex;
    align-items: center;
    margin-top: 15px;
`
export const Logsspan: StyledComponent<'span', any, any, never> = styled.span`
    width: auto;
    float: left;
    font-family: ${(props: any) => (props.primary ? 'Gordita-Regular' : 'Gordita-Medium')}
    cursor: ${(props: any) => (props.primary ? 'pointer' : 'default')}
    font-size: ${(props: any) => (props.primary ? '12px' : '15px')};
    margin-right:${(props: any) => (props.secondary ? '0px' : '5px')};
    margin-left:${(props: any) => (props.secondary ? '3px' : '3px')};
    color: ${(props: any) => (props.primary ? '#0a89e8' : '#494949')};
`

const Headerspan = styled.div`
    width: auto;
    float: left;
    margin: 0px 5px;
    color: #494949;
    font-family: 'Gordita-Regular';
    font-size: 12px;
    display: flex;
    align-items: center;
    padding-left: 5px;
`

const CalcWrapper: StyledComponent<'div', any, any, never> = styled.div`
    width: 100%;
    float: left;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    padding: ${(props: any) => (props.secondary ? '30px 0px 0px 0px' : '15px 0px')};
    border-top: ${(props: any) => (props.primary ? '1px solid #ccc' : 'none')};
    border-bottom: ${(props: any) => (props.primary ? '1px solid #ccc' : 'none')};
    margin-top: ${(props: any) => (props.primary ? '15px' : '0px')};
`

const CalcDivider: StyledComponent<'div', any, any, never> = styled.div`
    width: 67%;
    float: left;
    margin-bottom: ${(props: any) => (props.primary ? '15px' : '0px')};
    display: flex;
`

const CalcHeader = styled.h4`
    width: 85%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    color: #494949;
    font-family: 'Gordita-Regular';
    font-size: 22px;
    margin-bottom: 0px;
`
const CalcSpan = styled.span`
    width: auto;
    float: left;
    font-size: 14px;
    color: #494949;
    margin-left: 5px;
    font-family: 'Gordita-Regular';
`
const CalcHeaderRight = styled.h4`
    width: 12%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    color: #494949;
    font-family: 'Gordita-Regular';
    font-size: 24px;
    margin-bottom: 0px;
`
const Sup = styled.sup`
    width: auto;
    float: left;
    font-size: 16px;
    color: #494949;
    font-family: 'Gordita-Regular';
`
const Amount = styled.span`
    width: auto;
    float: left;
    font-size: 26px;
    color: #494949;
    font-family: 'Gordita-Medium';
`

const BillingLinks = styled.div`
    width: 100%;
    float: left;
    color: #0a89e8;
    font-family: 'Gordita-Regular';
    font-size: 15px;
    margin-top: 10px;
`
const BillingLinksSpan = styled.div`
    width: auto;
    float: left;
    cursor: pointer;
    color: #466af3;
    :hover {
        text-decoration: underline;
    }
`
const InformationIcon = styled.span`
    width: 10px;
    height: 10px;
    position: absolute;
    right: 22px;
    margin-top: 1px;
`
type Unwrap<T> = T extends Promise<infer U>
    ? U
    : T extends (...args: any) => Promise<infer U>
    ? U
    : T extends (...args: any) => infer U
    ? U
    : T

export const formatStripeDate = (date: number) => {
    return formatDate(new Date(date * 1000))
}

export const Estimate = (props: any) => {
    const { workspacename } = props.match.params

    const [PageState, setPageState] = useState<PageStateT>({ action: ActionT.Loading })
    useEffect(() => {
        const nextProps = props

        if (nextProps.state.type == 'loading') {
            setPageState({ action: ActionT.Loading })
        } else if (nextProps.state.type == 'error') {
            if (nextProps.state.error.response) {
                if (nextProps.state.error.response.data.tag === 'WORKSPACE_NOT_FOUND') {
                    setPageState({ action: ActionT.CustomerNotFound })
                    return
                }
            } else if (
                nextProps.state.error.response &&
                (nextProps.state.error.response.status == 401 || nextProps.state.error.response.status == 403)
            ) {
                setPageState({ action: ActionT.Unauthorized })
                return
            } else {
                setPageState(ErrorPage)
                return
            }
        } else if (nextProps.state.type == 'success') {
            const subscriptionDetails: Unwrap<ReturnType<typeof loadCurrentSubscriptionData>> = nextProps.state.data
            if (subscriptionDetails.subscription.status === ('trialing' as TrialStatus)) {
                setPageState({ action: ActionT.CustomerInTrial, subscription: subscriptionDetails })
            } else {
                setPageState({ action: ActionT.View, subscription: subscriptionDetails } as any)
            }
        }
    }, [props.state])

    if (PageState.action === ActionT.CustomerInTrial) {
        props.history.push(`/workspace/${workspacename}/billing/plans`)
    }

    if (PageState.action === ActionT.Loading) {
        return <Loader.PageLoader show={true} />
    }

    if (PageState.action === ActionT.View && PageState.subscription.subscription.status !== 'trialing') {
        const upcomingInvoice = PageState.subscription.subscription.stripeSubscription.upcomingInvoice
        const planBillingPeriod = PageState.subscription.planDetails.billed
        // console.log('upcomingInvoice', upcomingInvoice)

        const detailsToDisplay = {
            planName: PageState.subscription.displayName,
            startDate: formatStripeDate(upcomingInvoice.period_start),
            endDate: formatStripeDate(upcomingInvoice.period_end),
            toPay: upcomingInvoice.amount_due / 100
        }

        // console.log('upcoming', upcomingInvoice)
        return (
            <>
                <EstimateHeader />
                <BoxWrapper>
                    <Container>
                        <Box>
                            <BoxRight secondary width={6.6}>
                                <HeaderRight>Billing Estimate</HeaderRight>
                                <DateLogs>
                                    <Logsspan>{detailsToDisplay.startDate}</Logsspan>
                                    <Logsspan>-</Logsspan>
                                    <Logsspan>{detailsToDisplay.endDate}</Logsspan>
                                </DateLogs>
                                <HeaderPrice primary>
                                    {detailsToDisplay.planName}
                                    <Headerspan>
                                        (To upgrade the plan, go to{' '}
                                        <Logsspan
                                            primary
                                            secondary
                                            onClick={() =>
                                                props.history.push(
                                                    `/workspace/${workspacename}/billing/plans?from=estimate&planType=${planBillingPeriod.toLowerCase()}`
                                                )
                                            }
                                        >
                                            pricing plans
                                        </Logsspan>
                                        )
                                    </Headerspan>
                                </HeaderPrice>
                                <Table>
                                    <Thead>
                                        <Tr>
                                            <Th size={8} primary>
                                                Description
                                            </Th>

                                            <Th size={4}>Amount</Th>
                                        </Tr>
                                    </Thead>

                                    <Tbody>
                                        {upcomingInvoice.lines.data.map((lineItem, index) => (
                                            <Tr key={index}>
                                                <Td size={8} ContentRight>
                                                    {lineItem.description}
                                                </Td>
                                                <Td size={4}>{lineItem.amount / 100}</Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                                <CalcWrapper primary>
                                    <CalcDivider primary>
                                        <CalcHeader>
                                            Total <CalcSpan></CalcSpan>
                                        </CalcHeader>
                                        <CalcHeaderRight>
                                            <Sup>$</Sup>
                                            <Amount>{detailsToDisplay.toPay}</Amount>
                                        </CalcHeaderRight>
                                    </CalcDivider>
                                </CalcWrapper>
                            </BoxRight>

                            <BoxOne secondary BoxWidth={3}>
                                <HeaderLeft>Billing Information</HeaderLeft>
                                <BillingLinks>
                                    <BillingLinksSpan>
                                        <a
                                            href="https://workativ.com/conversational-ai-platform/pricing"
                                            target="blank"
                                        >
                                            Billing FAQs
                                        </a>
                                    </BillingLinksSpan>
                                </BillingLinks>
                                <BillingLinks>
                                    <BillingLinksSpan>
                                        <a href={`mailto:${billingEmail}`}>Contact us about your billing </a>
                                    </BillingLinksSpan>
                                </BillingLinks>
                            </BoxOne>
                        </Box>
                    </Container>
                </BoxWrapper>
            </>
        )
    }
    return <div> Unhandled Scenario </div>
}

const descriptitonToProduct = (description: string) => {
    if (description.includes('Assistant')) {
        return 'Assistant'
    }

    return null
}

export const toBillingEstimateV2 = (
    invoice: UpcomingInvoice
): { tag: 'NONE' } | { tag: 'HAS_PLAN_AMOUNT'; amount: string } => {
    if (invoice.lines === undefined) {
        return { tag: 'NONE' }
    }

    const lines = invoice.lines.data

    const consumption = lines
        .filter(line => {
            const rType = descriptitonToProduct(line.description)

            return rType != null
        })
        .map(line => {
            const toPay = {
                count: line.amount / 100
            }

            return toPay
        })
    if (consumption.length == 0) {
        return { tag: 'NONE' }
    }
    return {
        tag: 'HAS_PLAN_AMOUNT',
        amount: consumption[0].count.toString()
    }
}

export function EstimateV2(props: any) {
    const { workspacename } = props.match.params

    const [PageState, setPageState] = useState<PageStateT>({ action: ActionT.Loading })
    useEffect(() => {
        const nextProps = props

        if (nextProps.state.type == 'loading') {
            setPageState({ action: ActionT.Loading })
        } else if (nextProps.state.type == 'error') {
            if (nextProps.state.error.response) {
                if (nextProps.state.error.response.data.tag === 'WORKSPACE_NOT_FOUND') {
                    setPageState({ action: ActionT.CustomerNotFound })
                    return
                }
            } else if (
                nextProps.state.error.response &&
                (nextProps.state.error.response.status == 401 || nextProps.state.error.response.status == 403)
            ) {
                setPageState({ action: ActionT.Unauthorized })
                return
            } else {
                setPageState(ErrorPage)
                return
            }
        } else if (nextProps.state.type == 'success') {
            const subscriptionDetails: Unwrap<ReturnType<typeof loadCurrentSubscriptionData>> = nextProps.state.data
            if (subscriptionDetails.subscription.status === ('trialing' as TrialStatus)) {
                setPageState({ action: ActionT.CustomerInTrial, subscription: subscriptionDetails })
            } else {
                setPageState({ action: ActionT.View, subscription: subscriptionDetails } as any)
            }
        }
    }, [props.state])

    if (PageState.action === ActionT.CustomerInTrial) {
        props.history.push(`/workspace/${workspacename}/billing/plans`)
    }

    if (PageState.action === ActionT.Loading) {
        return <Loader.PageLoader show={true} />
    }

    if (PageState.action === ActionT.View && PageState.subscription.subscription.status !== 'trialing') {
        const upcomingInvoice = PageState.subscription.subscription.stripeSubscription.upcomingInvoice
        const planBillingPeriod = PageState.subscription.planDetails.billed
        const invoices = PageState.subscription.subscription.stripeSubscription.invoice
        const currentPlanType = PageState.subscription.planDetails.billed

        const planName = PageState.subscription.displayName
        const currentCycleStartDate = stripeUTCDate(PageState.subscription.subscription.current_period_start)
        const currentCycleEndDate = stripeUTCDate(PageState.subscription.subscription.current_period_end)
        // console.log('upcomingInvoice', upcomingInvoice)

        const detailsToDisplay = {
            planName: PageState.subscription.displayName,
            startDate: formatStripeDate(upcomingInvoice.period_start),
            endDate: formatStripeDate(upcomingInvoice.period_end),
            toPay: upcomingInvoice.amount_due / 100
        }

        const resourceWithDisplayDetails: (ResourceDisplay &
            ResourceConsumptionForDisplay)[] = PageState.subscription.resourceConsumption
            .map(resource => {
                const displayDetails = ResourceDetails.find(displayDetail => displayDetail.name === resource.id)
                if (displayDetails === undefined) {
                    return undefined
                }

                return {
                    ...resource,
                    ...displayDetails
                }
            })
            .filter(x => x !== undefined && (x.name === 'SESSION' || x.name === 'AUTOMATION'))
            .filter((item): item is ResourceDisplay & ResourceConsumptionForDisplay => !!item)

        const addOnAmount = resourceWithDisplayDetails
            .map(resource => ({
                exceeded: Math.max(parseInt(resource.consumed) - resource.resourceLimit, 0)
            }))
            .reduce((acc, curr) => acc + curr.exceeded * 0.1, 0)

        const gotoPlans = () => {
            // console.log('planTYpe', planType)
            props.history.push(`/workspace/${workspacename}/billing/plans`)
        }

        const toPlanEstimate = toBillingEstimateV2(upcomingInvoice)
        return (
            <div className="plansWrapper">
                    <PlansHeaderV2 backButton name={'Billing Estimate'} goBack={() => window.history.back()} />
                    <div className="current_plan_wrapper">
                        <BodyWrapper>
                            <WrapperV2>
                                <ContainerV2>
                                    <BillingWrapper>
                                        <OverviewPlanV2
                                            currentPlan={planName}
                                            currentPeriodEnd={currentCycleEndDate}
                                            currentPeriodStart={currentCycleStartDate}
                                            gotoPlans={gotoPlans}
                                            pricing={{ tag: 'NONE' }}
                                            planReferenceName={PageState.subscription.referenceName}
                                        />
                                        <BillingContainer className="ddd">
                                            <BillingContact>
                                                <BillingEstimationContainer>
                                                    <CurrentPlanHeader>Billing Estimate</CurrentPlanHeader>
                                                    <MonthlySubscriptionV2 fontBold padding>
                                                        {planName}{' '}
                                                        <UpgradePlanContent>
                                                            (To upgrade your plan, go to{' '}
                                                            <UpgradePlanContent fontSpan={true} onClick={gotoPlans}>
                                                                Pricing Plans
                                                            </UpgradePlanContent>
                                                            )
                                                        </UpgradePlanContent>
                                                    </MonthlySubscriptionV2>
                                                    <DateWrapper>
                                                        {detailsToDisplay.startDate} - {detailsToDisplay.endDate}
                                                    </DateWrapper>
                                                </BillingEstimationContainer>
                                                <TableContainerV2 resources={resourceWithDisplayDetails} />
                                                <BillItemsV2
                                                    addOnAmount={addOnAmount.toString()}
                                                    planAmount={toPlanEstimate}
                                                    planName={planName}
                                                    borderNone={true}
                                                    billingDate={formatStripeDate(upcomingInvoice.period_end)}
                                                />
                                            </BillingContact>
                                            <BillingInformation header={'Billing Information'} />
                                        </BillingContainer>
                                    </BillingWrapper>
                                </ContainerV2>
                            </WrapperV2>
                        </BodyWrapper>
                    </div>
                </div>
        )
    }
    return <div> Unhandled Scenario </div>
}
export const AccountEstimate = () => {
    return (
        <div className="plansWrapper">
            <PlansHeaderV2 backButton name={'Billing Estimate'} />
            <CurrentPlan />
        </div>
    )
}

const CurrentPlan = (props: any) => {
    return (
        <div className="current_plan_wrapper">
            <BodyWrapper>
                <WrapperV2>
                    <ContainerV2>
                        <BillingWrapper>
                            <BillingContainer>
                                <BillingEstimation upgradePlan />
                                <BillingInformation header={'Billing Estimate'} />
                            </BillingContainer>
                        </BillingWrapper>
                    </ContainerV2>
                </WrapperV2>
            </BodyWrapper>
        </div>
    )
}
export const BillingEstimateWrapper = styled.section`
    width: 100%;
    float: left;
    padding: 0px 20px;
    padding-top: 10px;
    padding-bottom: 20px;
    ${MonthlySubscriptionV2} {
        width: 100%;
        float: left;
    }
`

export const BillingContainer = styled.div`
    width: 100%;
    float: left;
    display: grid;
    grid-template-columns: 50% 24.34%;
    grid-gap: 40px;
    padding: 30px 20px 0px;
    justify-content: flex-start;
    height: calc(100vh - 360px);
    overflow-y: scroll;

    ${BillingContact} {
        ${CurrentPlanHeader} {
            padding: 20px 20px 15px 20px;
            border-bottom: 1px solid #d3d3d3;

            // @media (max-width: 1700px) {
            //     padding: 15px 20px 10px 20px;
            // }
            // @media (max-width: 1500px) {
            //     padding: 15px 20px 10px 20px;
            // }
        }
    }

    @media (max-width: 1700px) {
        padding: 20px 20px 0px;
        height: calc(100vh - 290px);
        overflow-y: scroll;
        margin-bottom: 20px;
    }
    @media (max-width: 1600px) {
        overflow-y: scroll;
        padding: 20px 20px 0px;
        height: calc(100vh - 300px);
    }
`
{
    /* <BillingLinks>
                                    <BillingLinksSpan>
                                        <a href="https://workativ.com/conversational-ai-platform/pricing" target="blank">
                                            Billing FAQs
                                        </a>
                                    </BillingLinksSpan>
                                </BillingLinks>
                                <BillingLinks>
                                    <BillingLinksSpan>
                                        <a href={`mailto:${billingEmail}`}>Contact us about your billing </a>
                                    </BillingLinksSpan>
                                </BillingLinks> */
}
export const BillingInformation = (props: any) => {
    return (
        <BillingContact>
            <BillingEstimationContainer>
                <CurrentPlanHeader>{props.header}</CurrentPlanHeader>
                <BillingEstimateWrapper>
                    <MonthlySubscriptionV2 fontBold>
                        <a href="https://workativ.com/conversational-ai-platform/pricing" target="blank">
                            Billing FAQs
                        </a>
                    </MonthlySubscriptionV2>
                    <MonthlySubscriptionV2 fontBold>
                        <a href={`mailto:${billingEmail}`}>Contact us about your billing</a>
                    </MonthlySubscriptionV2>
                </BillingEstimateWrapper>
            </BillingEstimationContainer>
        </BillingContact>
    )
}

const BodyWrapper = styled.section`
    width: 100%;
    float: left;
    padding: 20px;
    height: calc(100vh - 100px);
    overflow-y: inherit;
    ${BillingWrapper} {
        padding-bottom: 40px;
    }

    @media (max-width: 1700px) {
        ${BillingWrapper} {
            padding-bottom: 20px;
        }
    }
`
